import { render, staticRenderFns } from "./GP4BC_states.vue?vue&type=template&id=13f10fa6&scoped=true&"
import script from "./GP4BC_states.vue?vue&type=script&lang=js&"
export * from "./GP4BC_states.vue?vue&type=script&lang=js&"
import style0 from "./GP4BC_states.vue?vue&type=style&index=0&id=13f10fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f10fa6",
  null
  
)

export default component.exports